import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";

const SectionTile = ({ cls, selectedSections, setSelectedSections }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  return (
    <div
      className={`section-tile-container ${
        selectedSections &&
        selectedSections.includes(cls?._id) &&
        "selected-section"
      }`}
      onClick={() =>
        !location.pathname.includes("create-message")
          ? navigate(
              `/Messages/${params.course_code}/${cls._id}/course-messages`
            )
          : selectedSections.includes(cls?._id)
          ? setSelectedSections((prevState) =>
              prevState.filter((sec) => sec !== cls?._id)
            )
          : setSelectedSections([...selectedSections, cls?._id])
      }
    >
      <h3>
        {cls?.program} {cls?.semester}
      </h3>
      <h2>{cls?.section}</h2>
      {selectedSections?.includes(cls?._id) && <IoCheckmarkCircle />}
    </div>
  );
};

export default SectionTile;
